export default __webpack_public_path__ + "static/2-d96373ea05d997809d990173b4395412.jpg";